export default __webpack_public_path__ + "static/backgroundAwards--blurV-3db5dff3e75b06034678b0b5de331e97.webp";